// @flow
import React, { type Node, useContext } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { useRouter } from 'Client/router/useRouter';
import { CollapsePanel } from 'Components/frameworks/collapse-panel/CollapsePanel.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { HASH_PARAMS_DELIMITER } from 'Utils/uri/constants';
import { type IconName } from 'Components/frameworks/icon/Icon.jsx';
import { props, type CMSProps } from './collapsePanel.resolver';

export type CollapsePanelCMSProps = CMSProps;

export type CollapsePanelProps = {
  componentId: string,
  children?: Node,
  header: string,
  icon: IconName,
  collapseLabel?: string,
  expandLabel?: string,
  displayed: boolean,
};

export const panelProps = props;

export function Panel({
  displayed,
  children = <div />,
  componentId,
  header,
  icon,
  collapseLabel = '',
  expandLabel = '',
}: CollapsePanelProps) {
  const {
    location: { hash },
  } = useRouter<{}, {}>();
  const { isAppMounted } = useContext(ResponsiveContext);
  const cleanedHash = hash && isAppMounted ? hash.split(HASH_PARAMS_DELIMITER)[0] : null;
  const defaultExpanded = cleanedHash ? cleanedHash === `#${componentId}` : false;

  return displayed ? (
    <div className="Line Line-ProductInformation">
      <SiteContainer>
        <CollapsePanel
          as="h2"
          collapseLabel={collapseLabel}
          isExpanded={defaultExpanded}
          expandLabel={expandLabel}
          title={header}
          iconName={icon}
          id={componentId}
          trackingData={{
            actionGA: 'blockInfos',
            labelGA: componentId,
          }}
        >
          {children}
        </CollapsePanel>
      </SiteContainer>
    </div>
  ) : null;
}
